var map = {
	"./de/countries.json": [
		34001,
		1
	],
	"./en/countries.json": [
		76045,
		45
	],
	"./es/countries.json": [
		19954,
		954
	],
	"./ru/countries.json": [
		21151,
		151
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 92225;
module.exports = webpackAsyncContext;